// AppLandingPage.jsx
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Row, Col } from "react-bootstrap";
import toast from "react-hot-toast";
import "./customer_app_css/AppLandingPage.scss";
import Header from "../Layout/Header";
import SupplierConstantsList from "../common/SupplierConstants";
import CustomerConstantsList from "../common/CustomerConstants";
import LogisticsConstantsList from "../common/LogisticsConstants";
import PLMConstantsList from "../common/PLMConstants";
import PDMConstantsList from "../common/PDMConstants";
import AP_AUTOConstantsList from "../common/AP_AUTOConstants";
import ASSETConstantList from "../common/ASSETConstants";

import { useNavigate } from "react-router-dom";

//Redux
import { useDispatch } from "react-redux";
import { updateAppCode } from "../redux/feature/appSlice";
import { initializeAppData } from "../AppDataUtils";

//Service
import ItemService from "../services/supplier_appCommonService";
import WarehouseConstants from "../common/WarehouseConstants";
import FactoryConstants from "../common/FactoryConstants";
import SCConstants from "../common/SCConstants";
import LedgerConstants from "../common/LedgerConstants";
import HRConstants from "../common/HRConstants";


const AppLandingPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [getAppData, setAppData] = useState([]);

  const handleApplications = (code) => {
    console.log(">> handleApplications", code);
    dispatch(updateAppCode(code));

    localStorage.setItem("application", code);

    // Calling Application Data
    initializeAppData(dispatch, code);

    if (code === "ALL") {
      navigate(SupplierConstantsList.APP_HOME);
    } else if (code === "SUPPLIER") {
      navigate(SupplierConstantsList.HOME_INTRO);
    } else if (code === "CUSTOMER") {
      navigate(CustomerConstantsList.HOME_INTRO);
    } else if (code === "LOGISTICS") {
      navigate(LogisticsConstantsList.HOME_INTRO);
    } else if (code === "HR") {
      navigate(HRConstants.HOME_INTRO);
    } else if (code === "PLM") {
      navigate(PLMConstantsList.HOME_INTRO);
    } else if (code === "PDM") {
      navigate(PDMConstantsList.HOME_INTRO);
    }else if (code === "ASSET") {
      navigate(ASSETConstantList.HOME_INTRO);
    } else if (code === "WAREHOUSE") {
      navigate(WarehouseConstants.HOME_INTRO);
    } else if (code === "FACTORY") {
      navigate(FactoryConstants.HOME_INTRO);
    } else if (code === "CONSTRUCTION") {
      navigate(SCConstants.HOME_INTRO);
    } else if (code === "AP_AUTO") {
      navigate(AP_AUTOConstantsList.HOME_INTRO);
    } else if (code === "LEDGER") {
      navigate(LedgerConstants.HOME_INTRO);
    } else {
      toast.error(`${code} not yet Configured..!`, {
        duration: 4000,
        position: "top-right",
      });
    }
  };

  const getApplicationMaster = async () => {
    let obj = {};
    await ItemService.getApplicationMaster(obj).then((item) => {
      if (item?.status === 200) {
        setAppData(item?.data[0].appsName);
      } else {
        setAppData([]);
        console.log(">> Error: Loading getApplicationMaster");
      }
    });
  };

  useEffect(() => {
    getApplicationMaster();
  }, []);

  // keep your existing medium/large logic
  const activeCards = getAppData.filter((card) => card.appStatus);
  const colSize = activeCards.length > 6 ? 4 : 6;

  return (
    <main className="dashboard main appLandingPage">
      <Header />
      <div className="appInnerBlock">
        <Row className="justify-content-center subContent width-80">
          {getAppData.map(
            (card, index) =>
              card.appStatus && (
                <Col
                  key={index}
                  xs={12}
                  sm={6}
                  md={colSize}
                  lg={colSize}
                  className="mb-4 commLeftRightPadding d-flex"
                >
                  <motion.div
                    className="appCardWrapper w-100"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.2, duration: 0.5 }}
                    onClick={() => handleApplications(card.appCode)}
                  >
                    <div
                      className="appCardTopBorder"
                      style={{ backgroundColor: card.color }}
                    />

                    <div className="appCardContent">
                      <div>
                        <h3 className="appCardTitle">{card.appName}</h3>
                        <p className="appCardDesc">{card.description}</p>
                      </div>

                      <div className="appCardIcon">
                        <img src={card.icon} alt="icon" />
                      </div>
                    </div>
                  </motion.div>
                </Col>
              ),
          )}
        </Row>
      </div>
    </main>
  );
};

export default AppLandingPage;
